/* eslint-disable @typescript-eslint/no-explicit-any */
import { VStack, HStack, Grid, Skeleton, Button } from '@chakra-ui/react';
import { MainTemplate } from '../../templates/MainTemplate';
import { Label } from '../../components/atoms/Label';
import { useTheme } from '../../contexts/ThemeProvider';
import { useSales } from '@partiu/api/club/hooks';
import { CardHistory } from './components/CardHistory';
import { FaFrown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export function OrderHistoryPage() {
  const { colors, id } = useTheme();
  const { data, isFetching } = useSales(id || 0);

  const navigation = useNavigate();

  return (
    <MainTemplate>
      <VStack align={'self-start'} width="90%" marginBottom={'100px'} paddingTop={'20px'} spacing={6}>
        <HStack>
          <Label>Histórico de compra</Label>
        </HStack>
        {!isFetching && data?.length === 0 && (
          <VStack margin={'auto'} spacing={5} paddingTop={'50px'}>
            <FaFrown size="50px" color={colors.primaryColor} />
            <Label>Você ainda não possui compras!</Label>
            <Button
              borderColor={colors.primaryColor}
              variant="outline"
              color={colors.primaryColor}
              onClick={() => navigation('/vantagens')}
            >
              Ver vantagens
            </Button>
          </VStack>
        )}
        <Grid
          templateColumns={{
            base: 'repeat(1, 1fr)',
            md: 'repeat(2, 1fr)',
          }}
          width="100%"
          gap={4}
        >
          {isFetching && (
            <>
              {new Array(8).fill(0).map((_, i) => (
                <Skeleton key={i} width="100%" borderRadius={'16px'} height="160px" />
              ))}
            </>
          )}
          {!isFetching && data?.map((p) => <CardHistory {...p} />)}
        </Grid>
      </VStack>
    </MainTemplate>
  );
}
